module.exports = __webpack_public_path__ + "img/printer-label-tec1.097a08ab.jpg";